import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
import { SkapaColors, SkapaTokens } from '@inter-ikea-guida/skapa';
import { ExitButton } from '../../components/buttons/ExitButton';
import { UPPTACKA_HEADER_HEIGHT } from '../../utils/constants';
import { GuidaUpptackaHeader } from './GuidaUpptackaHeader';
const StyledMain = styled.main `
  margin-top: ${UPPTACKA_HEADER_HEIGHT};
  margin-inline: ${SkapaTokens.space300};
`;
const StyledContent = styled.div `
  height: calc(100vh - ${UPPTACKA_HEADER_HEIGHT});
  width: 100%;
  display: flex;
  flex-direction: row;
`;
const StyledHeaderContentContainer = styled.div `
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
const StyledHeaderButtonContainer = styled.div `
  display: flex;
  flex-direction: row;
  gap: ${SkapaTokens.space100};
`;
// Since upptäcka uses a button style that is not available in skapa we style it ourselves
const StyledHeaderButtonContainerUpptackaStyle = styled(StyledHeaderButtonContainer) `
  * {
    background-color: ${SkapaColors.colourNeutral2};
    color: ${SkapaColors.colourNeutral7};
  }

  :hover {
    * {
      background-color: unset;
    }
  }
`;
export const GuidaUpptackaLayout = ({ children, exitButtonText, onExitClicked, startHeaderButtons, endHeaderButtons }) => {
    return (_jsxs(_Fragment, { children: [_jsx(GuidaUpptackaHeader, { onExitClicked: onExitClicked, children: _jsxs(StyledHeaderContentContainer, { children: [_jsxs(StyledHeaderButtonContainerUpptackaStyle, { children: [_jsx(ExitButton, { buttonText: exitButtonText, onClick: onExitClicked }), startHeaderButtons] }), _jsx(StyledHeaderButtonContainer, { children: endHeaderButtons })] }) }), _jsx(StyledMain, { children: _jsx(StyledContent, { children: children }) })] }));
};
//# sourceMappingURL=GuidaUpptackaLayout.js.map